/**
 * Requires
 */

import $ from 'jquery'

let offset = 0
let openState = false

/**
 * Initialisation
 */

export function initialise() {
  if ($('[data-summary-tickets]').length) {
    const $toggle = $('[data-summary-tickets]')
    const $toggleTarget = $('[data-event-sticky-footer]')
    const elementOffset = $toggle.offset()
    $(window).on('scroll', function() {
      offset = $(document).scrollTop()
      let height = $(document).height()
      let atBottom = offset + $(window).height() === height
      if (elementOffset.top < offset && !openState) {
        $toggleTarget.addClass('open')
        openState = true
      } else if ((elementOffset.top > offset || atBottom) && openState) {
        $toggleTarget.removeClass('open')
        openState = false
      }
    })
  }
}
